import defaultPeterPictureAvif from '~/static/default/peter.jpg?as=avif&width=500';
import defaultPeterPicture from '~/static/default/peter.jpg?as=jpg&width=500';
import defaultPeterPictureWebp from '~/static/default/peter.jpg?as=webp&width=500';
import defaultPictureAvif from '~/static/default/user.png?as=avif&width=500';
import defaultPicture from '~/static/default/user.png?as=jpg&width=500';
import defaultPictureWebp from '~/static/default/user.png?as=webp&width=500';

import { chooseBestImage, getPictureLink } from '../../../common/resizer';
import Action from '../../Action';

import * as style from './style.module.css';

const UserPicture = ({ picture = null, animatedPicture = null, id = null, role = 'USER', isPeter = false, login = '', slug = '', isOnline = false, className = '', showBorders = false, size = null, action = null, children = null }) => {
  const computedAction = action || (id && !isPeter ? `/users/${id}/${slug}` : ['PREMIUM', 'MODERATOR', 'ADMINISTRATOR'].includes(role) ? `/users/?tag=${role.toLowerCase()}` : null);
  const image = getPictureLink(picture, { w: 400 });

  return (
    <Action style={size ? { '--size': size } : {}} title={login} action={computedAction} className={`${style.userPicture} ${showBorders ? style.borders : ''} ${className}`}>
      <div className={style.content}>
        <div className={style.contentItem} style={{ backgroundImage: `url('${chooseBestImage(isPeter ? [defaultPeterPicture, defaultPeterPictureWebp, defaultPeterPictureAvif] : [defaultPicture, defaultPictureWebp, defaultPictureAvif])}')` }} />
        {!isPeter && picture && <div className={style.contentItem} style={{ backgroundImage: `url('${image}')` }} />}
        {animatedPicture && <video poster={image} className={style.contentItem} src={animatedPicture} muted loop autoPlay playsInline={true} disablePictureInPicture={true} />}
        {animatedPicture && <div className={style.contentItem} />}
      </div>
      {isOnline && <div className={style.online} />}
      {children}
    </Action>
  );
};

export default UserPicture;
